import React, { useState, useEffect, useRef } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
// import ImageWithBasePath from '../../core/img/imagewithbasebath';
import {
  ChevronUp,
  PlusCircle,
} from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../core/redux/action";
import AddCoupons from "../../core/modals/coupons/addcoupons";
// import EditCoupons from '../../core/modals/coupons/editcoupons';
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useToast } from "../../Toaster/ToastContext";
import Loader from "../loader/loader";
import { apiClient } from "../../services/apiClient";
import Table from "../../core/pagination/datatable";

const Coupons = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const [coupons, setCoupons] = useState([]);
  const [filteredCoupons, setFilteredCoupons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentCoupon, setCurrentCoupon] = useState(null);
  const { showToast } = useToast();
  const hasFetched = useRef(false);
  const [permissions, setPermissions] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  });

  // const renderTooltip = (props) => (
  //     <Tooltip id="pdf-tooltip" {...props}>
  //         Pdf
  //     </Tooltip>
  // );
  // const renderExcelTooltip = (props) => (
  //     <Tooltip id="excel-tooltip" {...props}>
  //         Excel
  //     </Tooltip>
  // );
  // const renderPrinterTooltip = (props) => (
  //     <Tooltip id="printer-tooltip" {...props}>
  //         Printer
  //     </Tooltip>
  // );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const fetchCoupons = async (force = false) => {
    if (hasFetched.current && !force) return;
    setLoading(true);
    try {
      const response = await apiClient.post("/all-coupon", {
        pageIndex: 0,
        pageSize: 50,
        previousPageIndex: 0,
      });
      const data = await response;
      if (data.success) {
        setCoupons(data.data);
        setFilteredCoupons(data.data);
      } else {
        setCoupons([]);
        setFilteredCoupons([]);
      }
    } catch (error) {
      showToast(error.message || "Failed to fetch coupons", "error", "Coupons");
    } finally {
      setLoading(false);
      hasFetched.current = true;
    }
  };

  // useEffect(() => {
  //   fetchCoupons();
  // }, []);

  useEffect(() => {
    fetchCoupons();
    const storedPermissions = localStorage.getItem("rolespermissions");
    let parsedPermissions = [];
    try {
      const Permissions = JSON.parse(storedPermissions);
      const getPermissions = JSON.parse(Permissions.permissions);

      if (getPermissions.permissions) {
        parsedPermissions = getPermissions.permissions;
      } else {
        parsedPermissions = getPermissions;
      }

      // ✅ Find Promo section
      const promoPermissions = parsedPermissions.find(
        (item) => item.title === "Promo"
      );

      // ✅ Find Coupons inside Promo
      const couponsPermissions = promoPermissions?.childPage?.find(
        (child) => child.title === "Coupons"
      );

      if (couponsPermissions) {
        setPermissions({
          create: couponsPermissions.create || false,
          read: couponsPermissions.read || false,
          update: couponsPermissions.update || false,
          delete: couponsPermissions.delete || false,
        });
      } else {
        console.error("Coupons permissions not found in localStorage");
        showToast(
          "Coupons permissions not found.",
          "error",
          "Permissions Error"
        );
      }
    } catch (error) {
      console.error("Error parsing permissions from localStorage:", error);
      showToast("Failed to load permissions.", "error", "Permissions Error");
    }
  }, []);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();

    if (!term) {
      setFilteredCoupons(coupons);
      return;
    }

    setFilteredCoupons(
      coupons.filter(
        (coupon) =>
          (coupon.name && coupon.name.toLowerCase().includes(term)) ||
          (coupon.code && coupon.code.toLowerCase().includes(term)) ||
          (coupon.discount_type &&
            coupon.discount_type.toLowerCase().includes(term)) ||
          (coupon.discount_value &&
            coupon.discount_value.toString().toLowerCase().includes(term)) ||
          (coupon.max_users &&
            coupon.max_users.toString().toLowerCase().includes(term))
      )
    );
  };

  const handleToggleStatus = async (coupon) => {
    const newStatus = coupon.status === "active" ? "inactive" : "active";
    try {
      setLoading(true);
      const response = await apiClient.post("/coupon/save", {
        id: coupon.id,
        status: newStatus,
        name: coupon.name,
        code: coupon.code,
        discount_type: coupon.discount_type,
        discount_value: coupon.discount_value,
        max_users: coupon.max_users,
        start_date: coupon.start_date,
        end_date: coupon.end_date,
      });
      if (response.success) {
        showToast(
          `Coupon status updated to ${newStatus}`,
          "success",
          "Coupon Operation"
        );
        setCoupons((prev) =>
          prev.map((c) =>
            c.id === coupon.id ? { ...c, status: newStatus } : c
          )
        );
        setFilteredCoupons((prev) =>
          prev.map((c) =>
            c.id === coupon.id ? { ...c, status: newStatus } : c
          )
        );
      } else {
        showToast(
          response.message || "Failed to update coupon status",
          "error",
          "Coupon Operation"
        );
      }
    } catch (error) {
      showToast(
        error.message || "Failed to update coupon status",
        "error",
        "Coupon Operation"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleAddCoupon = () => {
    setCurrentCoupon(null);
  };

  const handleEditCoupon = (coupon) => {
    setCurrentCoupon(coupon);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => a.name.length - b.name.length,
      render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
      width: 200,
    },
    {
      title: "Code",
      dataIndex: "code",
      sorter: (a, b) => a.code.length - b.code.length,
      render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
      width: 200,
    },
    {
      title: "Discount Type",
      dataIndex: "discount_type",
      sorter: (a, b) => a.discount_type.length - b.discount_type.length,
      render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
      width: 150,
    },
    {
      title: "Discount Value",
      dataIndex: "discount_value",
      sorter: (a, b) => a.discount_value.length - b.discount_value.length,
      render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
      width: 150,
    },
    {
      title: "Max User",
      dataIndex: "max_users",
      sorter: (a, b) => a.max_users.length - b.max_users.length,
      render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
      width: 150,
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      sorter: (a, b) => a.start_date.length - b.start_date.length,
      render: (text) => {
        const date = new Date(text);
        return isNaN(date)
          ? "N/A"
          : date
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .split("/")
              .join("-");
      },
      width: 150,
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      sorter: (a, b) => a.end_date.length - b.end_date.length,
      render: (text) => {
        const date = new Date(text);
        return isNaN(date)
          ? "N/A"
          : date
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .split("/")
              .join("-");
      },
      width: 150,
    },

    // ✅ Status column: only show if read permission is true
    ...(permissions.read
      ? [
          {
            title: "Status",
            dataIndex: "status",
            render: (text, record) => (
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={text === "active"}
                  onChange={() => handleToggleStatus(record)}
                 
                />
                <span className="toggle-slider"></span>
              </label>
            ),
            sorter: (a, b) => a.status.length - b.status.length,
            width: 100,
          },
        ]
      : []),

    // Actions column: only if read OR delete
    ...(permissions.read || permissions.delete
      ? [
          {
            title: "Actions",
            dataIndex: "actions",
            key: "actions",
            render: (_, record) => (
              <div className="action-table-data">
                <div className="edit-delete-action">
                  {permissions.read && (
                    <Link
                      className="me-2 p-2"
                      to="#"
                      onClick={() => handleEditCoupon(record)}
                      data-bs-toggle="modal"
                      data-bs-target="#add-units"
                    >
                      <i data-feather="edit" className="feather-edit"></i>
                    </Link>
                  )}
                  {permissions.delete && (
                    <Link
                      className="confirm-text p-2"
                      to="#"
                      onClick={() => showConfirmationAlert(record)}
                    >
                      <i data-feather="trash-2" className="feather-trash-2"></i>
                    </Link>
                  )}
                </div>
              </div>
            ),
            width: 100,
          },
        ]
      : []),
  ];

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (record) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const response = await apiClient.get(`/delete-coupon/${record.id}`);
          const data = await response;
          if (data.success) {
            showToast(
              "Coupon deleted successfully",
              "success",
              "Coupon Operation!"
            );
            fetchCoupons(true);
          } else {
            showToast(
              data.message || "Failed to delete coupon",
              "error",
              "Coupon Operation!"
            );
          }
        } catch (error) {
          showToast(
            error.message || "Failed to delete coupon",
            "error",
            "Coupon Operation!"
          );
        } finally {
          setLoading(false);
        }
      } else {
        MySwal.close();
      }
    });
  };

  return (
    <div>
      <Loader loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Coupons</h4>
                <h6>Manage Your Coupons</h6>
              </div>
            </div>
            <ul className="table-top-head">
              {/* <li>
                            <OverlayTrigger placement="top" overlay={renderTooltip}>
                                <Link>
                                    <ImageWithBasePath src="https://odabill.com/assets/img/icons/pdf.svg" alt="img" />
                                </Link>
                            </OverlayTrigger>
                        </li>
                        <li>
                            <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                    <ImageWithBasePath src="https://odabill.com/assets/img/icons/excel.svg" alt="img" />
                                </Link>
                            </OverlayTrigger>
                        </li>
                        <li>
                            <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>
                                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                    <i data-feather="printer" className="feather-printer" />
                                </Link>
                            </OverlayTrigger>
                        </li> */}
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            <div className="page-btn">
              {/* <Link
                to="#"
                className="btn btn-added"
                data-bs-toggle="modal"
                data-bs-target="#add-units"
                onClick={handleAddCoupon}
              >
                <PlusCircle className="me-2" />
                Add New Coupons
              </Link> */}
              {permissions.create && (
                <Link
                  to="#"
                  className="btn btn-added"
                  onClick={handleAddCoupon}
                  data-bs-toggle="modal"
                  data-bs-target="#add-units"
                >
                  <PlusCircle className="me-2" />
                  Add New Coupons
                </Link>
              )}
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search by name and code "
                      className="form-control form-control-sm formsearch"
                      onChange={handleSearch}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={filteredCoupons}
                  rowKey={(record) => record.id}
                  rowSelection={null}
                />
              </div>

              {/* <div className="table-responsive">
                                <table className="table datanew">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Code</th>
                                            <th>Type</th>
                                            <th>Discount</th>
                                            <th>Limit</th>
                                            <th>Used</th>
                                            <th>Valid</th>
                                            <th>Status</th>
                                            <th className="no-sort">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <label className="checkboxs">
                                                    <input type="checkbox" />
                                                    <span className="checkmarks" />
                                                </label>
                                            </td>
                                            <td>Coupons 21 </td>
                                            <td>
                                                <span className="badge badge-bgdanger">Christmas</span>
                                            </td>
                                            <td>Fixed</td>
                                            <td>$20</td>
                                            <td>04</td>
                                            <td>01</td>
                                            <td>04 Jan 2023</td>
                                            <td>
                                                <span className="badge badge-linesuccess">Active</span>
                                            </td>
                                            <td className="action-table-data">
                                                <div className="edit-delete-action">
                                                    <Link
                                                        className="me-2 p-2"
                                                        to="#"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#edit-units"
                                                    >
                                                        <i data-feather="edit" className="feather-edit" />
                                                    </Link>
                                                    <Link className="confirm-text p-2" to="#" onClick={showConfirmationAlert}>
                                                        <i data-feather="trash-2" className="feather-trash-2" />
                                                    </Link>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label className="checkboxs">
                                                    <input type="checkbox" />
                                                    <span className="checkmarks" />
                                                </label>
                                            </td>
                                            <td>First Offer </td>
                                            <td>
                                                <span className="badge badge-bgdanger">First Offer</span>
                                            </td>
                                            <td>Percentage</td>
                                            <td>10%</td>
                                            <td>47</td>
                                            <td>10</td>
                                            <td>15 Feb 2023</td>
                                            <td>
                                                <span className="badge badge-linesuccess">Active</span>
                                            </td>
                                            <td className="action-table-data">
                                                <div className="edit-delete-action">
                                                    <Link
                                                        className="me-2 p-2"
                                                        to="#"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#edit-units"
                                                    >
                                                        <i data-feather="edit" className="feather-edit" />
                                                    </Link>
                                                    <Link className="confirm-text p-2" to="#" onClick={showConfirmationAlert}>
                                                        <i data-feather="trash-2" className="feather-trash-2" />
                                                    </Link>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label className="checkboxs">
                                                    <input type="checkbox" />
                                                    <span className="checkmarks" />
                                                </label>
                                            </td>
                                            <td>Offer 40 </td>
                                            <td>
                                                <span className="badge badge-bgdanger">40% Offer</span>
                                            </td>
                                            <td>Fixed</td>
                                            <td>$20</td>
                                            <td>21</td>
                                            <td>14</td>
                                            <td>08 Apr 2023</td>
                                            <td>
                                                <span className="badge badge-linesuccess">Active</span>
                                            </td>
                                            <td className="action-table-data">
                                                <div className="edit-delete-action">
                                                    <Link
                                                        className="me-2 p-2"
                                                        to="#"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#edit-units"
                                                    >
                                                        <i data-feather="edit" className="feather-edit" />
                                                    </Link>
                                                    <Link className="confirm-text p-2" to="#" onClick={showConfirmationAlert}>
                                                        <i data-feather="trash-2" className="feather-trash-2" />
                                                    </Link>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label className="checkboxs">
                                                    <input type="checkbox" />
                                                    <span className="checkmarks" />
                                                </label>
                                            </td>
                                            <td>Subscription </td>
                                            <td>
                                                <span className="badge badge-bgdanger">FirstSub01</span>
                                            </td>
                                            <td>Fixed</td>
                                            <td>$20</td>
                                            <td>09</td>
                                            <td>07</td>
                                            <td>12 Aug 2023</td>
                                            <td>
                                                <span className="badge badge-linesuccess">Active</span>
                                            </td>
                                            <td className="action-table-data">
                                                <div className="edit-delete-action">
                                                    <Link
                                                        className="me-2 p-2"
                                                        to="#"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#edit-units"
                                                    >
                                                        <i data-feather="edit" className="feather-edit" />
                                                    </Link>
                                                    <Link className="confirm-text p-2" to="#" >
                                                        <i data-feather="trash-2" className="feather-trash-2" />
                                                    </Link>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div> */}
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
      {/* <AddCoupons
        coupon={currentCoupon}
        onSave={() => {
          hasFetched.current = false;
          fetchCoupons();
        }}
      /> */}
      <AddCoupons
        coupon={currentCoupon}
        onSave={() => {
          hasFetched.current = false;
          fetchCoupons();
        }}
        canUpdate={permissions.update}
        canCreate={permissions.create}
      />
    </div>
  );
};

export default Coupons;
